import React, { Component } from 'react';
import RecordLabels from './RecordLabels.js';
import YoutubeThumbnail from './YoutubeThumbnail.js';
import GenericSearcher from './GenericSearcher.js';
import PulseLoader from 'react-spinners/PulseLoader'
import DiscogsThumbnail from './DiscogsThumbnail.js';
import LabelRelease from './LabelRelease.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {getYoutubeTitle} from './getYoutubeTitle.js';
import Discogs from 'discogs/Discogs.js';

class RecordLabelsView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            labelReleases: [],
            searchTerms:'',
            recordLabels: [],
            history: [],
            releasesPage:1,
            selectedLabel: undefined,
            oldVideoId: props.videoId,
            goneBack: false,
            selectedRelease: undefined,
            isLoadingDiscogs: false,
        };
        this.discogs = new Discogs();
        this.addListeners();
        this.getRecordLabels();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.videoId !== this.state.videoId) {
            this.state.videoId = nextProps.videoId;
        } 

        return true;
    }

    addListeners() {
        window.addEventListener('get_record_labels', () => {
            this.getRecordLabels();
        });
    }

    onClickBack() {
        let history = [...this.state.history];
        let item = history.pop();
        if (!this.state.goneBack) {
            item = history.pop();
            this.state.goneBack = true;
        }

        this.state.history = history;

        if (item.labelReleases !== undefined && item.labelReleases.length > 0) {
            this.setState({
                labelReleases: item.labelReleases,
                recordLabels: [],
            });
        } else {
            this.setState({
                labelReleases: [],
                recordLabels: item.recordLabels,
            });
        } 

        if (item.videoId !== undefined) {
            this.setState({
                videoId: item.videoId
            });
        }

        if (item.selectedLabel !== undefined) {
            this.setState({
                selectedLabel: item.selectedLabel,
            });
        }

    }

    newHistory(videoId=this.state.videoId) {
        if (this.state.recordLabels.length === 0 &&
            this.state.labelReleases.length === 0) {
            return;
        }

        // don't add the same history we've already done
        if (this.state.history.some(history => history.equals(this.state))) {
            return;
        }

        let history = [...this.state.history]
            .concat([new HistoryItem(
                this.state.recordLabels,
                this.state.labelReleases,
                videoId,
                this.state.selectedLabel)]);

        this.setState({history: history, goneBack: false});
    }

    getLabel(id) {
        return this.state.recordLabels.filter(x => x.id === id)[0];

    }

    showLabelReleases(id, updateHistory=false) {
        var self = this;
        if (this.state.selectedLabel === undefined ||
            this.state.selectedLabel.id !== id) {
            this.state.selectedLabel = this.getLabel(id);
        }
        this.setState({isLoadingDiscogs: true});
        this.discogs.getLabelReleases(id, this.state.releasesPage)
            .then(ret => {
                this.setState({isLoadingDiscogs: false});
                if (updateHistory) {
                    this.newHistory();
                }
                this.state.recordLabels = [];
                this.state.labelReleases = ret.releases;
                if (updateHistory) {
                    this.newHistory();
                }
                this.setState(this.state);
            });
    }

    onClickNextReleases() {
        this.state.releasesPage++;
        this.setState(this.state);
        this.showLabelReleases(this.state.selectedLabel.id);
    }

    onClickPreviousReleases() {
        this.state.releasesPage--;
        this.setState(this.state);
        this.showLabelReleases(this.state.selectedLabel.id);
    }

    searchForRelease(release) {
        this.setState({selectedRelease: release});
        this.props.searchYoutube(release.artist + ' - ' + release.title);
    }

    onClickLabel(id) {
        this.setState({releasesPage: 1});
        this.showLabelReleases(id, true);
    }

    getRecordLabels(videoId=this.props.videoId, oldVideoId=this.state.videoId) {
        this.state.labelMode = true;
        this.state.labelReleases = [];
        this.state.searchResults = [];
        this.state.releasesPage = 1;
        var self = this;

        this.setState({isLoadingDiscogs: true});
        getYoutubeTitle(videoId)
            .then(title =>
                  this.discogs.getLabels(title)
                  .then(ret => {
                      this.setState({isLoadingDiscogs: false});
                      this.state.recordLabels = ret;
                      this.newHistory();
                      this.setState(this.state);
                  }));
    }


    render() {
        if (!this.props.show) {
            return (
                <div></div>
            );
        }

        return (
            <div>
             <div className="discogs-header">
                <ConditionedComponent condition={this.state.history.length > 0}>
                  <div
                    onClick={() => this.onClickBack()}
                    className="back-button">
                    Back
                  </div>
                </ConditionedComponent>
                <ConditionedComponent condition={this.state.recordLabels.length > 0}>
                  <YoutubeThumbnail
                    loadVideo={(x) => this.props.onClickResult(x)}
                    release={this.state.selectedRelease} videoId={this.state.videoId}/>
                </ConditionedComponent>
                <ConditionedComponent condition={this.state.labelReleases.length > 0}>
                  <DiscogsThumbnail
                    recordLabels={this.state.recordLabels} selectedLabel={this.state.selectedLabel}/>
                </ConditionedComponent>
              </div>
              <div className="pagination-pane">
                {this.state.releasesPage > 1 ?
                  <div onClick={() => this.onClickPreviousReleases()}
                    className='field-pagination-button'>Previous</div> : ''}
                {this.state.labelReleases.length > 0 ?
                  <div onClick={() => this.onClickNextReleases()}
                    className='field-pagination-button'>Next</div> : ''}
              </div>
              <PulseLoader
                sizeUnit={"px"}
                size={10}
                color={'#123abc'}
                loading={this.state.isLoadingDiscogs}
                />
              <ConditionedComponent condition={this.state.recordLabels.length > 0}>
                <RecordLabels
                  onClickLabel={(id) => this.onClickLabel(id)}
                  labels={this.state.recordLabels}
                  />
              </ConditionedComponent>
              <ConditionedComponent condition={this.state.labelReleases.length > 0}>
                <div className="record-labels-subheader">
                  Label Releases
                </div>
                {this.state.labelReleases.map(
                    (release) =>
                        <LabelRelease
                              release={release}
                          onClick={() => this.searchForRelease(release)}/>)} 
            </ConditionedComponent>
            </div>
        );
    }
}

class HistoryItem {
    constructor(recordLabels, labelReleases, videoId, selectedLabel) {
        this.recordLabels = recordLabels;
        this.labelReleases = labelReleases;
        this.videoId = videoId;
        this.selectedLabel = selectedLabel;
    }

    equals(state) {
        if (state.recordLabels.length > 0 && this.recordLabels.length > 0) {
            return JSON.stringify(state.recordLabels) === JSON.stringify(this.recordLabels);
        }

        if (state.labelReleases.length > 0 && this.labelReleases > 0) {
            return JSON.stringify(state.labelReleases) === JSON.stringify(state.labelReleases);
        }
        return false;
    }
}

export default RecordLabelsView;
